//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  DEFAULT_STOCK_LIMIT,
  HOURS_REMAINING_TO_DISPLAY_STOCK,
} from '../../config/constants'
import { getTimer } from '../../utils'

export default {
  props: {
    limit: {
      type: Number,
      default: DEFAULT_STOCK_LIMIT,
    },
    stock: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      interval: null,
      timer: getTimer(),
    }
  },
  computed: {
    shouldDisplayStock() {
      if (this.stock <= this.limit) {
        return true
      }

      if (this.timer.hours >= HOURS_REMAINING_TO_DISPLAY_STOCK) {
        return true
      }

      return false
    },

    stockToDisplay() {
      return this.stock >= this.limit ? this.limit : this.stock
    },

    timerFormatted() {
      const { hours, minutes, seconds } = this.timer

      return {
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      }
    },
  },
  mounted() {
    this.interval = setInterval(() => {
      this.timer = getTimer()
    }, 1000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
}
